import React from 'react';
import { Link, graphql, navigate, withPrefix } from 'gatsby';
import Layout from '../components/Layout';
import Newsletter from '../components/Newsletter';
import Footer from '../components/Footer';
import Navigation from '../components/Navigation';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import AgbSwitcher from '../components/AgbSwitcher';

const AgbPage = ({ pageContext: { locale }, ...props }) => {
  const { node: data } = props.data.AgbPageData.edges[0]
  const { edges: agbs } = props.data.agbs;
  return (
      <Layout>
        <Helmet>
          <html lang='de' /> 
          <title>Geschäftsbedingungen - presono</title>
          <meta
            name="description"
            content="Allgemeine Geschäftsbedingungen der presono GmbH"
          />
        </Helmet>
        <Navigation langSwitch={data.frontmatter.langSwitch} locale={locale} />
        <section>
          <div className="container">
            <div className="columns secondarypage impressum">
              <div className="columns is-12">

                <div className="row" id="row-175375495">
                  <div className="col small-12 large-12">
                      <div className="col-inner">

                        <div className="headliner top starfield b1 t1 pusher">
                          <h1>Allgemeine Geschäftsbedingungen <small>der presono GmbH</small></h1>
                        </div>
                        <AgbSwitcher agbs={agbs} />

                      </div>
                  </div>
                 
                </div>


              </div>
            </div>
          </div>
        </section>
        <Newsletter newsletter={data.frontmatter} locale={locale} />
        <Footer locale={locale} />
      </Layout>
  )
}

export default AgbPage;

AgbPage.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
}

export const pageQuery = graphql`
query AgbContent($locale: String) {

  AgbPageData: allMarkdownRemark(
    filter: {frontmatter: { pageKey: {eq: "page_agb"}, locale: { eq: $locale }}}
  ) {
    edges {
      node {
        fields {
          slug
        }
        frontmatter {
          pageKey
          langSwitch
        }
      }
    }
  }

  agbs: allMarkdownRemark(
    filter: {frontmatter: { pageKey: {eq: "agbs"}}}
    ) {
    edges {
      node {
        html
        fields {
          slug
        }
        frontmatter {
          title
          pageKey
          agb
          locale
          download
          buttonText
        }
      }
    }
  }
}
`;
